import { Select as MantineSelect, Group, Radio } from '@mantine/core'
import '../../styles/common/select.css'

const MantineSelectBox = ({
  options = [],
  data = [],
  children,
  onChange,
  value,
  width = '100px',
  height = '40px',
  style,
  styles,
  zIndex,
  withinPortal,
  ...props
}) => {
  const defaultText = children || 'All'

  const sourceData = options.length > 0 ? options : data

  const selectData = sourceData.map((option) => ({
    value: option.value,
    label: option.label,
  }))

  const renderSelectOption = ({ option, checked }) => (
    <Group gap="xs" style={{ padding: '8px 12px' }}>
      <Radio checked={checked} onChange={() => {}} color="#0D2A4F" size="sm" />
      <span style={{ color: '#333', fontSize: '16px' }}>{option.label}</span>
    </Group>
  )

  const comboboxProps = {}
  if (withinPortal !== undefined) {
    comboboxProps.withinPortal = withinPortal
  }
  if (zIndex !== undefined) {
    comboboxProps.zIndex = zIndex
  }
  if (withinPortal || zIndex) {
    comboboxProps.position = 'bottom-start'
  }

  return (
    <MantineSelect
      className="custom-mantine-select"
      data={selectData}
      placeholder={defaultText}
      value={value}
      onChange={onChange}
      {...(Object.keys(comboboxProps).length > 0 && { comboboxProps })}
      styles={{
        root: {
          width: width,
          height: height,
          ...style,
          ...(styles?.root || {}),
        },
        input: {
          height: '36px',
          textAlign: 'left',
          border: '1px solid #BFBFBF',
          borderRadius: '3px',
          fontSize: '14px',
          ...(styles?.input || {}),
        },
        rightSection: {
          display: 'none !important',
          ...(styles?.rightSection || {}),
        },
        dropdown: {
          marginTop: '5px',
          border: '1px solid #bfbfbf',
          borderRadius: '3px',
          minWidth: '200px',
          ...(zIndex && { zIndex: zIndex }),
          ...(styles?.dropdown || {}),
        },
        option: {
          padding: 0,
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
          ...(styles?.option || {}),
        },
      }}
      renderOption={renderSelectOption}
      {...props}
    />
  )
}

export default MantineSelectBox
